<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex justify-between">
    <drdp-title [title]="pageTitle"></drdp-title>
  </div>
  @if (isView) {
    <div class="flex justify-end">
      <a routerLink="/config/rating-views" class="self-center text-sm order-last cursor-pointer">
        <i class="uil uil-angle-left-b text-base"></i>{{ t('ratingViewSetup.customView.backToSetup') }}
      </a>
    </div>
  }
  <drdp-container additionClasses="mt-5">
    @if (!isView) {
      <div>
        <h2 class="text-[20px] font-bold mb-2">{{ t('ratingViewSetup.addAlternateRatingView') }}</h2>
        <hr>
        </div>
      }
      <form [formGroup]="customViewForm" #ngForm="ngForm">
        <div class="form-input-label-group">
          <label class="font-normal" [ngClass]="{'required': !isView }" for="title">{{ t('common.title') }}</label>
          <mat-form-field appearance="fill">
            <input class="display" [placeholder]="t('common.title')" matInput type="text" [readonly]="isView" formControlName="title"
              required>
            @if (title.invalid) {
              <mat-error>{{ t('ratingViewSetup.baseTemplate.titleRequired') }}</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-input-label-group">
          <label class="font-normal" [ngClass]="{'required': !isView }" for="description">{{ t('common.description') }}</label>
          <mat-form-field appearance="fill">
            <input class="display" [placeholder]="t('common.description')" matInput type="text" [readonly]="isView"
              formControlName="description" required>
            @if (description.invalid) {
              <mat-error>{{ t('ratingViewSetup.baseTemplate.descriptionRequired') }}</mat-error>
            }
          </mat-form-field>
        </div>
        @if (!isView) {
          <div class="form-input-label-group">
            <label class="font-normal" [ngClass]="{'required': !isView }" for="ageGradeInstrumentId">{{ t('common.ageGroup') }}</label>
            <mat-form-field appearance="fill" class="drdp-input">
              <mat-select formControlName="ageGradeInstrumentId" [placeholder]="t('ratingViewSetup.baseTemplate.selectBaseTemplatePlaceholder')" required
                [ngClass]="{'invalid' : ageGradeInstrumentId.invalid && ngForm.submitted }">
                <!-- Server-supplied option text: localized by the API, not by Transloco. -->
                @for (agi of ageGradeInstruments; track agi) {
                  <mat-option [value]="agi.id">
                    {{ agi.ageGradeInstrumentName }}
                  </mat-option>
                }
              </mat-select>
              @if (ageGradeInstrumentId.invalid) {
                <mat-error>{{ t('ratingViewSetup.baseTemplate.ageGroupRequired') }}</mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (isView) {
          <div class="self-start">
            <label class="font-normal" for="ageGradeInstrumentId">{{ t('common.ageGroup') }}</label>
            <mat-form-field appearance="fill">
              <input class="display" matInput [readonly]="isView" [value]="customTemplate?.ageGradeInstrument" type="text"
                formControlName="ageGradeInstrumentId" required>
            </mat-form-field>
          </div>
        }
        @if (!isView) {
          <div class="form-input-label-group mt-4">
            <label class="font-normal" [ngClass]="{'required': !isView }" for="ageGradeTemplateId">{{ t('common.baseTemplate') }}</label>
            <mat-form-field appearance="fill" class="drdp-input">
              <mat-select formControlName="ageGradeTemplateId" [placeholder]="t('ratingViewSetup.baseTemplate.selectAgeGroupPlaceholder')" required
                [ngClass]="{'invalid' : ageGradeInstrumentId.invalid && ngForm.submitted }">
                <!-- Server-supplied option text: localized by the API, not by Transloco. -->
                @for (abt of ageGradeBaseTemplates; track abt) {
                  <mat-option [value]="abt.id">
                    {{ abt.description }}
                  </mat-option>
                }
              </mat-select>
              @if (ageGradeTemplateId.invalid) {
                <mat-error>{{ t('ratingViewSetup.baseTemplate.baseTemplateRequired') }}</mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (isView) {
          <div class="self-start">
            <label class="font-normal" for="ageGradeTemplateId">{{ t('common.baseTemplate') }}</label>
            <mat-form-field appearance="fill">
              <input matInput class="display" [readonly]="isView" [value]="customTemplate?.ageGradeTemplate" type="text"
                formControlName="ageGradeTemplateId" required>
            </mat-form-field>
          </div>
        }
        <div class="mt-4">
          <h3 class="text-[18px] font-bold mb-2">{{ t('ratingViewSetup.customView.extraMeasures') }}</h3>
          @if (!displayMeasures) {
            <span> {{ t('ratingViewSetup.customView.extraMeasuresHint') }}</span>
          }
          <div class="grid grid-cols-2 md:grid-cols-8 mt-4">
            @for (domain of templateDomains; track domain) {
              <div>
                <div class="col-span-1">
                  <!-- Server-supplied domain and measure codes below. -->
                  <h4 class="text-[16px] font-bold mb-2">{{domain.domainCode}}</h4>
                  <mat-checkbox class="font-medium" (change)="checkDomainSelected(domain)" [checked]="domain.isAllSelected"
                    [disabled]="isView" [(ngModel)]="domain.isAllSelected" [ngModelOptions]="{standalone: true}">
                    {{ t('ratingViewSetup.customView.allDomain', { code: domain.domainCode }) }}
                  </mat-checkbox>
                  <div class="ml-2">
                    @for (measure of domain.measures; track measure) {
                      <div>
                        <mat-checkbox class="font-medium" (change)="checkDomainAllSelected(domain)"
                          [checked]="measure.isSelected" [disabled]="measure.isRequired || isView || domain.disableMeasures"
                          [(ngModel)]="measure.isSelected" [ngModelOptions]="{standalone: true}">
                          {{measure.code}}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        @if (hasAssignments) {
          <div class="mt-4">
            <h3 class="text-[18px] font-bold mb-2">{{ t('ratingViewSetup.customView.assignments') }}</h3>
            @if (siteAssignments.length > 0) {
              <div class="font-bold mt-2">{{ t('ratingViewSetup.customView.sites') }} </div>
            }
            <!-- Server-supplied site, classroom and student names below. -->
            @if (siteAssignments.length > 0) {
              <div class="grid grid-cols-4">
                @for (site of siteAssignments; track site) {
                  <div
                    class="ml-2 px-4 py-1 mx-1 mt-3 pr-3 rounded-full text-drdpblue-400 bg-drdpblue-500 text-sm">
                    {{site.siteName}}
                  </div>
                }
              </div>
            }
            @if (classAssignments.length > 0) {
              <div class="font-bold mt-4">{{ t('ratingViewSetup.customView.classrooms') }} </div>
            }
            @if (classAssignments.length > 0) {
              <div class="grid grid-cols-4">
                @for (class of classAssignments; track class) {
                  <div
                    class="ml-2 px-4 py-1 mx-1 mt-3 pr-3 rounded-full text-drdpblue-400 bg-drdpblue-500 text-sm">
                    {{class.className}}
                  </div>
                }
              </div>
            }
            @if (studentAssignments.length > 0) {
              <div class="font-bold mt-4">{{ t('ratingViewSetup.customView.students') }} </div>
            }
            @if (studentAssignments.length > 0) {
              <div class="grid grid-cols-4">
                @for (student of studentAssignments; track student) {
                  <div
                    class="ml-2 px-4 py-1 mx-1 mt-3 pr-3 rounded-full text-drdpblue-400 bg-drdpblue-500 text-sm">
                    {{student.studentName}}
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (canEditRatingViews) {
          <div class="mt-4 mb-2 flex justify-end">
            @if (!isView) {
              <drdp-btn type="button" color="cancel" (click)="cancel()"> {{ t('common.cancel') }} </drdp-btn>
            }
            @if (!isView) {
              <drdp-btn (click)="submitForm()" class="mx-4"> {{ t('common.save') }} </drdp-btn>
            }
            @if (isView || hasAssignments) {
              <drdp-btn class="mx-4" (click)="reassign()">{{ t('ratingViewSetup.customView.reassign') }}</drdp-btn>
            }
            @if (!isView || !hasAssignments) {
              <drdp-btn (click)="next()"
                [type]="isView ? 'button' : 'submit'">
                {{nextLabel}} <i class="uil uil-angle-right"></i> </drdp-btn>
              }
            </div>
          }
        </form>
      </drdp-container>
    </div>
</ng-container>
